module.exports = __webpack_public_path__ + "img/image3 copy.eb64448c.jpg";